import React, { Component } from "react";
import PropTypes from "prop-types";
import MediaQuery from "react-responsive";

import { find, findIndex, flow, get, keyBy, map, mapValues, noop, partialRight } from "lodash";

import Grid from "@material-ui/core/Grid";

import ListLayout from "../ListLayout";
import RatingItem from "../RatingItem";
import styles from "./RatingList.module.css";
import { createOplogEntry } from "../../utils/oplogHelpers";
import { generateOptionItem } from "../../utils/context";

class RatingList extends Component {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          text: PropTypes.string.isRequired,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            .isRequired,
        })
      ).isRequired,
      value: PropTypes.object,
      duration: PropTypes.number.isRequired,
      // Discarded questions generated by this question
      discarded: PropTypes.array,
      // Custom object storing variables
      custom: PropTypes.object,
      onInit: PropTypes.func,
      onChange: PropTypes.func
    };
  }

  static get defaultProps() {
    return {
      value: {},
      discarded: [],
      custom: null,
      onInit: noop,
      onChange: noop
    };
  }

  constructor(props) {
    super(props);

    const formatValue = flow([
      partialRight(keyBy, "name"),
      partialRight(mapValues, (option, key) =>
        get(props.value, key, {
          value: null
        })
      )
    ]);

    this.state = {
      value: formatValue(props.options)
    };

    this.handleChange = this.handleChange.bind(this);
    this.renderItem = this.renderItem.bind(this);
  }

  UNSAFE_componentWillMount () {
    // Pass state and answer to parent (Question) component right before being appended to DOM
    this.props.onInit(
      this.props.name,
      this.props.type,
      {
        options: map(this.props.options, generateOptionItem),
        discarded: this.props.discarded,
        custom: this.props.custom
      },
      this.props.value,
      this.props.duration
    );
  }

  componentDidMount() {
    // check to ensure that the oplog in entry isn't fired when this component is a child to the RatingGrid component
    if (!this.props.parentName) {
      this.props.doOplogUpdate(createOplogEntry(this.props.name, "in"));
    }
  }

  componentWillUnmount() {
    // check to ensure that the oplog out entry isn't fired when this component is a child to the RatingGrid component.
    if (!this.props.parentName) {
      this.props.doOplogUpdate(createOplogEntry(this.props.name, "out"));
    }
  }

  updateOplog(rating) {
    const action = "set";
    const optionsOrder = findIndex(this.props.options, { name: rating.name }) + 1;
    const order =
      this.props.groupIdx !== undefined
        ? `${this.props.groupIdx + 1 },${optionsOrder}`
        : `${optionsOrder}`;
    const id = `${this.props.parentName ?? ""}.${this.props.name}.${rating.name}`;
    const value = rating.value;

    this.props.doOplogUpdate(createOplogEntry(id, action, order, value));
  }

  handleChange(e, rating) {
    this.updateOplog(rating);
    const state = this.state;
    const option = find(this.props.options, { name: rating.name });
    state.value[option.name].value = option.value;
    state.value[option.name].score = rating.value;
    this.setState(state);

    this.props.onChange(e, state.value);
  }

  renderItem(option) {
    const currentState = this.state.value[option.name];

    // TODO: Migrate to react-flexbox-grid
    return (
      <MediaQuery key={option.name} maxWidth={480}>
        {matches =>
          matches ? (
            <div
              className="row"
              key={option.name}
              style={{ margin: "0.5em 1em 0.5em 1em" }}
            >
              <div className="col-xs-12">
                <label className={styles.optionText}>{option.text}</label>
              </div>
              <div className="col-xs-12">
                <RatingItem
                  name={option.name}
                  value={currentState.score}
                  onRatingChange={this.handleChange}
                />
              </div>
            </div>
          ) : (
            <Grid container alignItems="center" className={styles.row}>
              <Grid item xs={6}>
                <span className={styles.optionText}>{option.text}</span>
              </Grid>
              <Grid item xs={6}>
                <RatingItem
                  name={option.name}
                  value={currentState.score}
                  onRatingChange={this.handleChange}
                />
              </Grid>
            </Grid>
          )
        }
      </MediaQuery>
    );
  }

  render() {
    return (
      <ListLayout columns={1} width="100%">
        {this.props.options.map(o => this.renderItem(o))}
      </ListLayout>
    );
  }
}

export default RatingList;
